import React from "react";

const ProductHeader = () => {
  return (
    <>
      <div className="headerpage">
        <img
          src="/images/h-0.webp"
          alt="productpage"
        />
        <h3 className="headerpagetitle">product page</h3>
      </div>
    </>
  );
};

export default ProductHeader;
